import axiosInstance from '../axiosConfig';

export default {
  async getSearchByTerm(payload) {
    const response = await axiosInstance.post(
      'EcomBuscarProdPorTermino',
      payload
    );
    return response.data;
  },
};
